import ComoFaz from './ComoFaz'

export default ComoFaz
